import React from "react";
import styled from "styled-components";
import ActionHeader from "../../components/ActionHeader";
import { Button } from "baseui/button";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import request from "../../utils/http";
import { useState } from "react";
import { StyledTable, StyledHeadCell, StyledBodyCell } from "baseui/table-grid";
import { ProgressBar } from "baseui/progress-bar";
import enums from "../../utils/enums";
import { Tag } from "baseui/tag";
import { Check, Delete } from "baseui/icon";

const Container = styled.div``;

const StyledTableRow = styled.div`
	display: contents;
	cursor: pointer;
`;

const UserHome = (props: any) => {
	const urlParams = useParams() as any;
	const navigate = useNavigate();
	const [users, setUsers] = useState([] as any);

	const loadUsers = async () => {
		let result = await request("GET", `/api/admin/user/all`, null);
		if (result.success && result.data) {
			setUsers(result.data.users);
		}
	};

	useEffect(() => {
		loadUsers();
	}, [urlParams]);

	return (
		<Container>
			<ActionHeader>
				<h1>Users</h1>
				<Button
					onClick={() => {
						navigate({
							pathname: `/user/create`,
						});
					}}
				>
					Create
				</Button>
			</ActionHeader>
			<hr />
			<StyledTable role="grid" $gridTemplateColumns={"1fr 1fr 0.5fr 3fr"}>
				<StyledTableRow role="row">
					<StyledHeadCell>Name</StyledHeadCell>
					<StyledHeadCell>Email</StyledHeadCell>
					<StyledHeadCell>Active</StyledHeadCell>
					<StyledHeadCell>Roles</StyledHeadCell>
				</StyledTableRow>

				{users &&
					users.map((user: any, i: number) => {
						const striped = i % 2 === 0;

						return (
							<StyledTableRow
								role="row"
								onClick={() => {
									navigate({
										pathname: `/user/${user.id}`,
									});
								}}
							>
								<StyledBodyCell $striped={striped}>{user.name}</StyledBodyCell>
								<StyledBodyCell $striped={striped}>{user.email}</StyledBodyCell>
								<StyledBodyCell $striped={striped}>
									{user.active ? <Check /> : <Delete />}
								</StyledBodyCell>
								<StyledBodyCell $striped={striped}>
									{user.systemAdmin && (
										<>
											<Tag
												closeable={false}
												overrides={{ Text: { style: { maxWidth: "" } } }}
											>
												System Admin
											</Tag>
										</>
									)}
									{user.hrManager && (
										<>
											<Tag
												closeable={false}
												overrides={{ Text: { style: { maxWidth: "" } } }}
											>
												HR Manager
											</Tag>
										</>
									)}
									{user.payrollTeam && (
										<>
											<Tag
												closeable={false}
												overrides={{ Text: { style: { maxWidth: "" } } }}
											>
												Payroll Team
											</Tag>
										</>
									)}
									{user.payrollPilTeam && (
										<>
											<Tag
												closeable={false}
												overrides={{ Text: { style: { maxWidth: "" } } }}
											>
												PIL Create Team
											</Tag>
										</>
									)}
									{user.opsTeam && (
										<>
											<Tag
												closeable={false}
												overrides={{ Text: { style: { maxWidth: "" } } }}
											>
												Ops Team
											</Tag>
										</>
									)}
									{user.hrTeam && (
										<>
											<Tag
												closeable={false}
												overrides={{ Text: { style: { maxWidth: "" } } }}
											>
												HR Team
											</Tag>
										</>
									)}
								</StyledBodyCell>
							</StyledTableRow>
						);
					})}
			</StyledTable>
		</Container>
	);
};
export default UserHome;
